import { type ExamPreviewLoadingVariant } from './types';

export const EXAM_PREVIEW_LOADING_VARIANT_MAP: Record<
  ExamPreviewLoadingVariant,
  {
    title: string;
    message: string;
    style: string;
  }
> = {
  exam: {
    title: 'examPreviewLoading.exam.title',
    message: 'examPreviewLoading.exam.message',
    style: 'flex h-full w-full flex-col items-center justify-center gap-6',
  },
  instruction: {
    title: 'examPreviewLoading.instruction.title',
    message: 'examPreviewLoading.instruction.message',
    style: 'flex h-fit w-full flex-col items-center justify-center gap-6',
  },
};
